import { instance } from "api/apiBase";
import {
  MetaAdsAuthorizationUrl,
  MetaAdsConnection
} from "types/landlord/meta-ads";

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/meta_ads";

export const metaAdsApi = {
  getStatus: async (): Promise<MetaAdsConnection> => {
    const { data } = await instance.get<MetaAdsConnection>(BASE_ENDPOINT_URL);
    return data;
  },

  getAuthorizationUrl: async (): Promise<MetaAdsAuthorizationUrl> => {
    const { data } = await instance.get<MetaAdsAuthorizationUrl>(
      `${BASE_ENDPOINT_URL}/authorization_url`
    );
    return data;
  },

  disconnect: async (): Promise<void> => {
    await instance.delete(BASE_ENDPOINT_URL);
  }
};
